module.exports = __webpack_public_path__ + "img/header-form-game-back.a0870dd6.svg";